import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* createJob(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.JOB.CREATE_JOB, action.payload, true);
}

export function* updateJob(action: any): any {
  yield call(sagaFunction, action, CallApi.PUT, API_URL.JOB.UPDATE_JOB + action.payload.jobId, action.payload, true);
}
